(function () {
  'use strict';

  var cfg = window.enamorCart || {};
  var FREE_SHIPPING = cfg.freeShippingThreshold || 99900;
  var GIFT_THRESHOLD = (cfg.giftThreshold !== undefined && cfg.giftThreshold !== null) ? cfg.giftThreshold : 120000;
  var GIFT_PRODUCT_ID = cfg.giftProductId || 0;
  var GIFT_VARIANTS = cfg.giftVariants || {};
  var ADDON_HANDLE = cfg.addonHandle || '加購區';

  var drawer = document.getElementById('enamor-cart-drawer');
  var overlay = document.getElementById('enamor-cart-overlay');
  var itemsEl = document.getElementById('enamor-cart-items');
  var emptyEl = document.getElementById('enamor-cart-empty');
  var footerEl = document.getElementById('enamor-cart-footer');
  var totalEl = document.getElementById('enamor-cart-total');
  var progressFill = document.getElementById('enamor-progress-fill');
  var progressText = document.getElementById('enamor-progress-text');
  var shippingBar = document.getElementById('enamor-shipping-bar');
  var shippingText = document.getElementById('enamor-shipping-text');
  var giftModal = document.getElementById('enamor-gift-modal');
  var addonWrap = document.getElementById('enamor-addon-wrap');
  var addonTrack = document.getElementById('enamor-addon-track');

  var giftModalDismissed = false;
  var addonLoaded = false;

  if (!drawer) return;

  /* ---- Helpers ---- */

  function formatMoney(cents) {
    return 'NT$' + Math.round(cents / 100).toLocaleString('zh-TW');
  }

  function setLoading(state) {
    if (state) {
      itemsEl.classList.add('is-loading');
    } else {
      itemsEl.classList.remove('is-loading');
    }
  }

  /* ---- Open / close ---- */

  function openDrawer() {
    drawer.setAttribute('aria-hidden', 'false');
    drawer.classList.add('is-open');
    overlay.classList.add('is-visible');
    document.body.classList.add('enamor-drawer-open');
    fetchCart().then(renderCart);
    if (!addonLoaded) {
      addonLoaded = true;
      fetchAddonProducts();
    }
  }

  function closeDrawer() {
    drawer.setAttribute('aria-hidden', 'true');
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-visible');
    document.body.classList.remove('enamor-drawer-open');
    closeGiftModal();
  }

  /* ---- Fetch cart ---- */

  function fetchCart() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); });
  }

  /* ---- Render ---- */

  function renderCart(cart) {
    updateBadge(cart.item_count);
    updateStatusBars(cart.total_price);

    var hasItems = cart.item_count > 0;
    emptyEl.style.display = hasItems ? 'none' : '';
    footerEl.style.display = hasItems ? '' : 'none';
    shippingBar.style.display = hasItems ? '' : 'none';
    document.getElementById('enamor-progress-wrap').style.display = hasItems ? '' : 'none';

    if (!hasItems) {
      itemsEl.innerHTML = '';
      return;
    }

    itemsEl.innerHTML = cart.items.map(renderItem).join('');
    totalEl.textContent = formatMoney(cart.total_price);
    checkGift(cart);
  }

  function renderItem(item) {
    var isGift = item.product_id === GIFT_PRODUCT_ID;
    var imgHtml = item.image
      ? '<img src="' + item.image + '" alt="' + escHtml(item.title) + '" loading="lazy">'
      : '<div class="enamor-item-img-placeholder"></div>';

    var variantHtml = (item.variant_title && item.variant_title !== 'Default Title')
      ? '<p class="enamor-item-variant">' + escHtml(item.variant_title) + '</p>'
      : '';

    // Discount tags
    var discountHtml = '';
    if (!isGift && item.discounts && item.discounts.length > 0 && item.total_discount > 0) {
      discountHtml = '<div class="enamor-discount-tags">'
        + item.discounts.map(function (d) {
          return '<span class="enamor-discount-tag">' + escHtml(d.title)
            + '　-' + formatMoney(item.total_discount) + '</span>';
        }).join('')
        + '</div>';
    }

    // Line item properties (e.g. preorder delivery info)
    var propsHtml = '';
    if (item.properties) {
      var propLines = Object.keys(item.properties).filter(function (k) {
        return k.charAt(0) !== '_' && item.properties[k] !== '' && item.properties[k] !== null;
      }).map(function (k) {
        return '<span class="enamor-item-prop">' + escHtml(k) + '：' + escHtml(String(item.properties[k])) + '</span>';
      });
      if (propLines.length > 0) {
        propsHtml = '<div class="enamor-item-props">' + propLines.join('') + '</div>';
      }
    }

    var controlsHtml = isGift
      ? '<span class="enamor-gift-label">贈品</span>'
      : '<div class="enamor-qty">'
        + '<button class="enamor-qty-btn" data-action="minus" data-key="' + item.key + '" aria-label="減少數量">−</button>'
        + '<input type="number" class="enamor-qty-input" value="' + item.quantity + '" min="0" max="99" data-key="' + item.key + '" aria-label="數量">'
        + '<button class="enamor-qty-btn" data-action="plus" data-key="' + item.key + '" aria-label="增加數量">+</button>'
        + '</div>';

    return '<div class="enamor-cart-item" data-key="' + item.key + '">'
      + '<div class="enamor-item-img">' + imgHtml + '</div>'
      + '<div class="enamor-item-info">'
      + '<p class="enamor-item-title">' + escHtml(item.product_title) + '</p>'
      + variantHtml
      + discountHtml
      + propsHtml
      + '<div class="enamor-item-bottom">'
      + controlsHtml
      + '<span class="enamor-item-price">' + formatMoney(item.final_line_price) + '</span>'
      + (isGift ? '' : '<button class="enamor-item-remove" data-key="' + item.key + '" aria-label="移除">'
        + '<svg width="14" height="14" viewBox="0 0 14 14" fill="none">'
        + '<path d="M2 2L12 12M12 2L2 12" stroke="currentColor" stroke-width="0.5"/>'
        + '</svg></button>')
      + '</div>'
      + '</div>'
      + '</div>';
  }

  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ---- Status bars ---- */

  function updateStatusBars(totalPrice) {
    // Free shipping bar
    if (totalPrice >= FREE_SHIPPING) {
      shippingText.textContent = '已達免運門檻';
      shippingBar.classList.add('is-met');
    } else {
      var diff = Math.ceil((FREE_SHIPPING - totalPrice) / 100);
      shippingText.textContent = '再 NT$' + diff.toLocaleString('zh-TW') + ' 享免運費';
      shippingBar.classList.remove('is-met');
    }

    // Gift progress bar
    if (!GIFT_THRESHOLD || GIFT_THRESHOLD <= 0) return;
    var pct = Math.min((totalPrice / GIFT_THRESHOLD) * 100, 100);
    progressFill.style.width = pct + '%';

    if (totalPrice >= GIFT_THRESHOLD) {
      progressText.textContent = '已達贈品門檻';
      progressText.classList.add('is-met');
    } else {
      var giftDiff = Math.ceil((GIFT_THRESHOLD - totalPrice) / 100);
      progressText.textContent = '再 NT$' + giftDiff.toLocaleString('zh-TW') + ' 獲得贈品';
      progressText.classList.remove('is-met');
    }
  }

  /* ---- Badge ---- */

  function updateBadge(count) {
    var badges = document.querySelectorAll('[data-enamor-cart-badge]');
    badges.forEach(function (badge) {
      if (count > 0) {
        badge.textContent = count > 99 ? '99+' : count;
        badge.style.display = '';
      } else {
        badge.style.display = 'none';
      }
    });
  }

  /* ---- Gift logic ---- */

  function checkGift(cart) {
    if (!GIFT_THRESHOLD || GIFT_THRESHOLD <= 0) return;
    var isEligible = cart.total_price >= GIFT_THRESHOLD;
    var giftItem = cart.items.find(function (item) {
      return item.product_id === GIFT_PRODUCT_ID;
    });

    if (isEligible && !giftItem && !giftModalDismissed) {
      openGiftModal();
    } else if (!isEligible && giftItem) {
      giftModalDismissed = false;
      changeQuantity(giftItem.key, 0);
    }
  }

  function openGiftModal() {
    if (!giftModal) return;
    // Reset buttons
    giftModal.querySelectorAll('.enamor-gift-size-btn').forEach(function (btn) {
      btn.disabled = false;
      btn.textContent = btn.dataset.size || btn.textContent;
    });
    giftModal.setAttribute('aria-hidden', 'false');
    giftModal.classList.add('is-open');
  }

  function closeGiftModal() {
    if (!giftModal) return;
    giftModal.setAttribute('aria-hidden', 'true');
    giftModal.classList.remove('is-open');
  }

  /* ---- Addon carousel ---- */

  function fetchAddonProducts() {
    if (!addonWrap || !addonTrack) return;
    fetch('/collections/' + encodeURIComponent(ADDON_HANDLE) + '/products.json?limit=10')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.products && data.products.length > 0) {
          renderAddonCarousel(data.products);
          addonWrap.style.display = '';
        }
      })
      .catch(function () {});
  }

  function renderAddonCarousel(products) {
    if (!addonTrack) return;
    // 過濾：所有 variants 皆缺貨且非預購 → 不顯示
    products = products.filter(function (p) {
      if (!p.variants || p.variants.length === 0) return false;
      return p.variants.some(function (v) {
        return v.available || v.inventory_policy === 'continue';
      });
    });
    if (products.length === 0) {
      if (addonWrap) addonWrap.style.display = 'none';
      return;
    }
    addonTrack.innerHTML = products.map(function (p) {
      var img = p.images && p.images[0] ? p.images[0].src : '';
      var variant = p.variants[0];
      var price = variant ? Math.round(parseFloat(variant.price)) : 0;
      var compareAt = variant && variant.compare_at_price ? Math.round(parseFloat(variant.compare_at_price)) : null;
      var multiVariant = p.variants.length > 1;
      var canAdd = variant && (variant.available || variant.inventory_policy === 'continue');

      var priceHtml = (compareAt && compareAt > price)
        ? '<span class="enamor-addon-price">NT$' + price + '</span> <span class="enamor-addon-compare">NT$' + compareAt + '</span>'
        : '<span class="enamor-addon-price">NT$' + price + '</span>';

      var btnHtml = multiVariant
        ? '<a href="' + p.url + '" class="enamor-addon-btn enamor-addon-btn--link">選規格</a>'
        : canAdd
          ? '<button class="enamor-addon-btn" data-addon-variant="' + variant.id + '">加入</button>'
          : '<span class="enamor-addon-sold">已售完</span>';

      return '<div class="enamor-addon-card">'
        + (img ? '<div class="enamor-addon-img"><img src="' + img + '" alt="' + escHtml(p.title) + '" loading="lazy"></div>'
               : '<div class="enamor-addon-img enamor-addon-img--empty"></div>')
        + '<div class="enamor-addon-body">'
        + '<p class="enamor-addon-name">' + escHtml(p.title) + '</p>'
        + '<p class="enamor-addon-prices">' + priceHtml + '</p>'
        + btnHtml
        + '</div>'
        + '</div>';
    }).join('');

    // Bind arrow buttons
    var prevBtn = document.getElementById('enamor-addon-prev');
    var nextBtn = document.getElementById('enamor-addon-next');
    var SCROLL_STEP = 130;
    if (prevBtn) prevBtn.onclick = function () { addonTrack.scrollBy({ left: -SCROLL_STEP, behavior: 'smooth' }); };
    if (nextBtn) nextBtn.onclick = function () { addonTrack.scrollBy({ left: SCROLL_STEP, behavior: 'smooth' }); };
  }

  /* ---- Cart API ---- */

  function changeQuantity(key, quantity) {
    setLoading(true);
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        setLoading(false);
        renderCart(cart);
        return cart;
      })
      .catch(function () { setLoading(false); });
  }

  function addToCart(variantId, quantity) {
    quantity = quantity || 1;
    setLoading(true);
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return fetchCart(); })
      .then(function (cart) {
        setLoading(false);
        renderCart(cart);
        return cart;
      })
      .catch(function () { setLoading(false); });
  }

  /* ---- Event delegation: items ---- */

  itemsEl.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('.enamor-qty-btn');
    var removeBtn = e.target.closest('.enamor-item-remove');

    if (qtyBtn) {
      var key = qtyBtn.dataset.key;
      var wrap = qtyBtn.closest('.enamor-qty');
      var input = wrap ? wrap.querySelector('.enamor-qty-input') : null;
      var current = input ? parseInt(input.value, 10) : 1;
      var action = qtyBtn.dataset.action;
      var newQty = action === 'plus' ? current + 1 : Math.max(0, current - 1);
      if (input) input.value = newQty;
      changeQuantity(key, newQty);
    }

    if (removeBtn) {
      changeQuantity(removeBtn.dataset.key, 0);
    }
  });

  itemsEl.addEventListener('change', function (e) {
    var input = e.target.closest('.enamor-qty-input');
    if (!input) return;
    var newQty = Math.max(0, parseInt(input.value, 10) || 0);
    input.value = newQty;
    changeQuantity(input.dataset.key, newQty);
  });

  /* ---- Event delegation: gift modal ---- */

  if (giftModal) {
    giftModal.addEventListener('click', function (e) {
      var sizeBtn = e.target.closest('.enamor-gift-size-btn');
      var closeBtn = e.target.closest('[data-enamor-gift-close]');

      if (sizeBtn) {
        var variantId = sizeBtn.dataset.variant;
        var label = sizeBtn.textContent.trim();
        sizeBtn.disabled = true;
        sizeBtn.textContent = '加入中…';
        addToCart(variantId, 1).then(function () {
          sizeBtn.textContent = label;
          closeGiftModal();
        });
      }

      if (closeBtn) {
        giftModalDismissed = true;
        closeGiftModal();
      }
    });
  }

  /* ---- Event delegation: addon carousel ---- */

  if (addonTrack) {
    addonTrack.addEventListener('click', function (e) {
      var btn = e.target.closest('.enamor-addon-btn[data-addon-variant]');
      if (!btn) return;
      var variantId = btn.dataset.addonVariant;
      var label = btn.textContent;
      btn.disabled = true;
      btn.textContent = '加入中…';
      addToCart(variantId, 1).then(function () {
        btn.disabled = false;
        btn.textContent = label;
      });
    });
  }

  /* ---- Intercept add-to-cart form submissions ---- */

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.getAttribute('action') !== '/cart/add') return;
    if (form.dataset.noDrawer) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var submitBtn = form.querySelector('[type="submit"]:not([name="goto_pp"]):not([name="goto_gc"])');
    var originalText = submitBtn ? submitBtn.textContent : '';
    var originalDisabled = submitBtn ? submitBtn.disabled : false;

    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = '加入中…';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        if (submitBtn) {
          submitBtn.disabled = originalDisabled;
          submitBtn.textContent = originalText;
        }
        openDrawer();
      })
      .catch(function () {
        if (submitBtn) {
          submitBtn.disabled = originalDisabled;
          submitBtn.textContent = originalText;
        }
      });
  }, true);

  /* ---- Global click delegation ---- */

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-enamor-cart-open]')) {
      e.preventDefault();
      openDrawer();
      return;
    }
    if (e.target.closest('[data-enamor-cart-close]')) {
      closeDrawer();
      return;
    }
  });

  if (overlay) {
    overlay.addEventListener('click', closeDrawer);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* ---- Init badge on load ---- */

  fetchCart().then(function (cart) {
    updateBadge(cart.item_count);
  });

  /* ---- Expose open for external use (product page add-to-cart etc.) ---- */

  window.enamorCartOpen = openDrawer;

})();
